import { render, staticRenderFns } from "./ContratosDash.vue?vue&type=template&id=787ecfe6"
import script from "./ContratosDash.vue?vue&type=script&lang=js"
export * from "./ContratosDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports